import React, { useCallback, useMemo, useState } from "react";
import { useLazyQuery } from "@apollo/react-hooks";
import { Breadcrumb, message } from "antd";
import gql from "fraql";
import { get } from "lodash";
import ReportTableDisplayResults from "../utils/ReportTableDisplayResults";
import LayoutPageHeader from "../../LayoutPageHeader";
import ReportDataExportButton from "../ReportDataExportButton";
import IndividualSummaryReportForm from "./IndividualSummaryReportForm";
import "../SummaryReportPage.scss";

const GET_INDIVIDUAL_SUMMARY_REPORT = gql`
  query CompetitorsByCompetitionSummaryReportPage_GetCompetitorsByCompetitionReport($CompetitionIds: [ID!]!) {
    CompetitorsByCompetitionSummaryReport(competitionIds: $CompetitionIds) {
      result
    }
  }
`;

function IndividualSummaryReportPage() {
  const [getReport, { loading, data, error }] = useLazyQuery(GET_INDIVIDUAL_SUMMARY_REPORT, {
    onError: err => {
      console.error(err);
      message.error("Failed to generate the report.");
    },
  });

  const reportData = useMemo(() => get(data, "CompetitorsByCompetitionSummaryReport.result", null), [data]);

  const tableColumns = [
    { title: "Sport", dataIndex: "Sport", key: "Sport" },
    { title: "Competition", dataIndex: "Competition", key: "Competition" },
    { title: "Age group lower", dataIndex: "AgeGroupLower", key: "AgeGroupLower" },
    { title: "Age group upper", dataIndex: "AgeGroupUpper", key: "AgeGroupUpper" },
    { title: "Number of Players", dataIndex: "PlayerCount", key: "PlayerCount" },
  ];

  const handleSubmitForm = useCallback(
    async (values, actions) => {
      const { CompetitionIds } = values;
      getReport({ variables: { CompetitionIds } });
      actions.setSubmitting(false);
    },
    [getReport],
  );
  
  const [filteredRows, setFilteredRows] = useState([]);
    const filteredRowKeys = useMemo(() => {
      return filteredRows.map(row => row.key);
    }, [filteredRows]);

  let actions;

  if (reportData) {
    actions = (
      <>
        <ReportDataExportButton
          title="Individual Competitor  Summary Report"
          data={{ rows: reportData, columns: tableColumns.map(column => column.dataIndex) }}
          selectedRowKeys={filteredRowKeys}
          disabled={loading}
        />
      </>
    );
  } else {
    actions = null;
  }

  return (
    <>
      <div
        style={{
          borderBottom: "2px solid #e8e8e8",
          padding: "15px 24px",
        }}
      >
        <Breadcrumb style={{ marginBottom: 10 }}>
          <Breadcrumb.Item>Reports</Breadcrumb.Item>
          <Breadcrumb.Item>Individual Competitor Summary Report</Breadcrumb.Item>
        </Breadcrumb>

        <LayoutPageHeader title="Individual Competitor Summary Report" extra={actions} />
      </div>

      <div className="summary-report__container">
        <div className="summary-report__flex-container">
          <div className="summary-report__left-sidebar">
            <div className="summary-report__left-sidebar-content">
              <IndividualSummaryReportForm handleSubmit={handleSubmitForm} />
            </div>
          </div>
          <div className="summary-report__content">
            <ReportTableDisplayResults data={reportData} loading={loading} error={error} columns={tableColumns} setFilteredRows={setFilteredRows} />
          </div>
        </div>
      </div>
    </>
  );
}

export default IndividualSummaryReportPage;
